<template>
  <v-menu
    v-model="menu"
    offset-y
    max-height="304"
    :open-on-focus="true"
    :open-on-click="false"
    :close-on-click="true"
    :close-on-content-click="false"
  >
    <template #activator="{ on }">
      <w-autocomplete
        v-bind="filterProp"
        :value="internalValue"
        item-text="label"
        item-value="id"
        :items="flatItems"
        :loading="itemsPending"
        :menu-props="computedMenuProps"
        @keydown.tab="handleMenu(false)"
        @focus="handleMenu(true)"
        @update:search-input="updateSearch"
        @input="handleTreeview"
        @click:clear="internalValue = []"
        @click.native="handleNativeClick"
        v-on="on"
      >
        <template
          v-if="filterHasFilterOptions && withFilterOptions"
          #append
        >
          <MultipleSelectionFilterMenu
            :filter-options="filterOptions"
            :filter-option-text="filterOptionText"
            :option-select-disabled="optionSelectDisabled"
            @click:filterOption="handleFilterOption"
          />
        </template>
      </w-autocomplete>
    </template>
    <w-treeview
      ref="treeview"
      :value="internalValue"
      :items="sortedItems"
      :item-text="itemText"
      :item-children="itemChildren"
      item-key="id"
      selection-type="independent"
      selected-color="primary"
      selectable
      :search="computedSearch"
      hoverable
      activatable
      @input="handleTreeview"
      @update:active="handleActiveInput"
      @update:search="menu = true"
    />
  </v-menu>
</template>

<script>
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
import multipleSelectionMixin from '@/components/global_components/filters/multiple_selection_filter/shared/multiple-selection-mixin';
import multipleTreeSelectionMixin from '@/components/global_components/filters/multiple_selection_filter/shared/multiple-tree-selection-mixin';
import multipleTreeSearchMixin from '@/components/global_components/filters/multiple_selection_filter/shared/multiple-tree-search-mixin';
import multipleTreeMenuMixin from '@/components/global_components/filters/multiple_selection_filter/shared/multiple-tree-menu-mixin';
import sortedItems from '@/mixins/component/sorted-items-mixin';

export default {
  name: 'WorkMultipleTreeSelectionFilter',
  components: {
    MultipleSelectionFilterMenu: () =>
      import(
        '@/components/global_components/filters/multiple_selection_filter/shared/MultipleSelectionFilterMenu'
      )
  },
  props: {
    withFilterOptions: { type: Boolean, default: true },
    value: { type: [Array, Object], required: false },
  },
  mixins: [
    multipleSelectionMixin(WorkAutocomplete.props),
    sortedItems,
    multipleTreeSelectionMixin,
    multipleTreeSearchMixin,
    multipleTreeMenuMixin
  ],
};
</script>
<style lang="scss" scoped>
::v-deep .w-treeview {
  min-height: 1rem;

  .v-treeview-node--leaf>.v-treeview-node__root {
    padding-left: 0.5rem !important;
  }

  .v-treeview-node .v-treeview-node__root {
    padding-left: 0
  }
}
</style>
